export enum BlockColor {
  ORANGE = "orange",
  BLUE = "blue",
  PURPLE = "purple",
}
